import { Document, Font, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import React from "react";
import PropTypes from "prop-types";

Font.register({
  family: "Vazir",
  src: "/fonts/Vazirmatn-FD-Medium.ttf",
});

const PdfWeightPage = ({ data, totals }) => {
  const styles = StyleSheet.create({
    page: {
      padding: 20,
      fontSize: 10,
      fontFamily: "Vazir",
      flexDirection: "column",
      direction: "rtl"
    },
    summaryContainer: {
      flexDirection: "row-reverse",
      justifyContent: "space-between",
      marginBottom: 10,
      borderWidth: 1,
      borderColor: "#000",
      padding: 5,
      backgroundColor: "#f9f9f9"
    },
    summaryItem: {
      fontSize: 10,
      fontWeight: "bold",
    },
    title: {
      textAlign: "center",
      fontSize: 14,
      fontWeight: "bold",
      marginBottom: 10,
      direction: "rtl"

    },
    table: {
      display: "table",
      width: "auto",
      borderStyle: "solid",
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
      marginBottom: 20,
      direction: "rtl"

    },
    tableRow: {
      flexDirection: "row-reverse",
    },
    tableColHeader: {
      width: "10%",
      borderStyle: "solid",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      backgroundColor: "#f0f0f0",
      textAlign: "center",
      padding: 3,
      fontWeight: "bold",
      direction: "rtl"
    },
    tableCol: {
      width: "10%",
      borderStyle: "solid",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      textAlign: "center",
      padding: 3,
      direction: "rtl",
    },
    textLeft: {
      textAlign: "left",
      width: "10%",
      borderStyle: "solid",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      padding: 3,
      direction: "rtl",
    },
    pageFooter: {
      textAlign: "center",
      fontSize: 9,
      marginTop: 10,
      direction: "rtl"

    },
    tableCol2: {
      width: "10%",
      borderStyle: "solid",
      borderWidth: 1,
      borderLeftWidth: 1,
      borderTopWidth: 0,
      borderRightWidth: 1,
      borderBottomWidth: 1,
      textAlign: "center",
      padding: 3,
      direction: "rtl",
    },
    tableRow2: {
      flexDirection: "row-reverse",
      borderTopWidth: 1,
      borderTopColor: "black",
    },

  });

  const parsePelak = (pelak) => {
    if (!pelak) return { part1: "--", part2: "--", part3: "--", part4: "--" };
    return {
      part1: pelak.slice(0, 2),
      part2: pelak.slice(2, 3),
      part3: pelak.slice(3, 6),
      part4: pelak.slice(6),
    };
  };
  const totalWeightFill = data.reduce(
    (sum, item) => sum + Number(item?.weight_fill || 0),
    0
  );
  const totalNetWeight = data.reduce(
    (sum, item) =>
      sum +
      (item.weight_fill != null && item.weight_empty != null
        ? Number(item?.weight_fill) - Number(item?.weight_empty)
        : 0),
    0
  );
  return (
    <Document>
      <Page size="A4" style={styles.page} orientation="landscape">
        <Text style={styles.title}>{process.env.REACT_APP_PDF_TITLE || "گزارش باسکول"}</Text>

        {totals && (
          <View style={styles.summaryContainer}>
            <Text style={styles.summaryItem}>تعداد بارگیری: {totals.loading_count}</Text>
            <Text style={styles.summaryItem}>تعداد تخلیه: {totals.unloading_count}</Text>
            <Text style={styles.summaryItem}>مجموع تناژ بارگیری: {totals.loading_tonnage}</Text>
            <Text style={styles.summaryItem}>مجموع تناژ تخلیه: {totals.unloading_tonnage}</Text>
          </View>
        )}

        <View style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={styles.tableColHeader}>تاریخ</Text>
            <Text style={styles.tableColHeader}>ساعت</Text>
            <Text style={styles.tableColHeader}>نوع عملیات</Text>
            <Text style={styles.tableColHeader}>شماره قبض</Text>
            <Text style={styles.tableColHeader}>توزین خالی</Text>
            <Text style={styles.tableColHeader}>توزین پر</Text>
            <Text style={styles.tableColHeader}>توزین خالص</Text>
            <Text style={styles.tableColHeader}>کالا</Text>
            <Text style={styles.tableColHeader}>نام دستگاه</Text>
            <Text style={styles.tableColHeader}>پلاک</Text>
          </View>

          {data.map((item, index) => (
            <View style={styles.tableRow} key={index}>
              <Text style={styles.tableCol}>  {item.date
                ? item.date.split(" ")[1].split("-").reverse().join("-")
                : "--"}</Text>
              <Text style={styles.tableCol}>{item.date?.split(" ")[0] ?? "--"}</Text>
              <Text style={styles.tableCol}>
                {item.type_full === 1 ? "بارگیری" : item.type_full === 2 ? "تخلیه" : item.type ?? "--"}
              </Text>
              <Text style={styles.tableCol}>{item.cargo_code ?? "--"}</Text>
              <Text style={styles.tableCol}>{item.weight_empty ?? "--"}</Text>
              <Text style={styles.tableCol}>{item.weight_fill ?? "--"}</Text>
              <Text style={styles.tableCol}>
                {item.weight_fill != null && item.weight_empty != null
                  ? item.weight_fill - item.weight_empty
                  : "--"}
              </Text>
              <Text style={styles.tableCol}>{item.weight_jens?.title ?? "--"}</Text>
              <Text style={styles.tableCol}>{item.machine?.name ?? "--"}</Text>
              <Text style={styles.tableCol}>
                {item.plate
                  ? `${parsePelak(item.plate).part4} ${parsePelak(item.plate).part3} ${parsePelak(item.plate).part2} ${parsePelak(item.plate).part1}`
                  : "--"}
              </Text>
            </View>
          ))}
        </View>
        <View style={[styles.tableRow2, { marginTop: 5, marginBottom: 5, borderTopWidth: 1, borderTopColor: "black" }]}>
          <Text style={[styles.tableCol2, { width: "50%", paddingBottom: 5 }]}>
            مجموع توزین خالص: {totalNetWeight}
          </Text>
          <Text style={[styles.tableCol2, { width: "50%", paddingBottom: 5 }]}>
            مجموع توزین پر: {totalWeightFill}
          </Text>
        </View>

        <Text style={styles.pageFooter}>
          (نرم افزار مدیریت بارگیری بارگو) 91096293-021 www.bargosoftware.com
        </Text>
      </Page>
    </Document>
  );
};

PdfWeightPage.propTypes = {
  data: PropTypes.array.isRequired,
  totals: PropTypes.object,
};

export default PdfWeightPage;
